export default (object, predicate) =>
  JSON.parse(
    JSON.stringify(object, (key, value) => {
      if (predicate(value)) {
        return undefined; // `undefined` cause to unset key-value pair @sinslav
      }
      return value;
    }),
  );
